import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { addContact, clearContact, loadAllContactPaginated, loadSingleContact, updateContact } from "@/redux/rtk/features/CRM/contact/contactSlice";
import { Button, Form, Steps, Card } from "antd";
import LeadsCreateMany from "../../Lead/Leads/LeadsCreateMany";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ContactAddress from "./ContactAddress";
import ContactInformation from "./ContactInformation";

export default function AddContact({ onClose, createAs, data, drawer }) {
  const { t } = useTranslation();
  // selector
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [current, setCurrent] = useState(0);
  const { contact, loading: contactLoading } = useSelector(
    (state) => state.contact
  );

  useEffect(() => {
    if (data?.id) {
      dispatch(loadSingleContact(data.id)).then(() => {
        form.setFieldsValue({
          ...data,
          dateOfBirth: data.dateOfBirth
            ? dayjs(data.dateOfBirth).format("YYYY-MM-DD")
            : null,
        });
      });
    } else {
      form.resetFields();
    }

    return () => dispatch(clearContact());
  }, [data, dispatch, form]);

  const next = async () => {
    try {
      await form.validateFields();
      setCurrent(current + 1);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const formData = {
      ...values,
      dateOfBirth: values.dateOfBirth
        ? dayjs(values.dateOfBirth).format("YYYY-MM-DD")
        : null,
      contactOwnerId: parseInt(values.contactOwnerId),
      agentId: parseInt(values.agentId),
      industryId: parseInt(values.industryId),
      contactSourceId: parseInt(values.contactSourceId),
      contactStageId: parseInt(values.contactStageId),
    };

    let resp;

    // checking if i have id i will hit update or i will hit add
    if (data?.id) {
      resp = await dispatch(updateContact({ id: data.id, values: formData }));
      if (resp.payload.message === "success") {
        dispatch(
          loadAllContactPaginated({
            page: 1,
            count: 10,
          })
        );
      }
    } else {
      resp = await dispatch(addContact(formData));
    }
    if (resp.payload.message === "success") {
      form.resetFields();
      if (createAs) {
        dispatch(createAs.singleLoadThunk(createAs.value));
      } else {
        dispatch(
          loadAllContactPaginated({
            page: 1,
            count: 10,
          })
        );
        !drawer ? navigate(`/admin/contact/${resp?.payload?.data?.id}`) : "";
      }
    }
  };
  const onCancel = () => {
    form.resetFields();
    onClose();
  };
  const userId = localStorage.getItem("id");

  useEffect(() => {
    if (!data?.id && userId) {
      form.setFieldsValue({
        contactOwnerId: parseInt(userId),
      });
    }
  }, [form, userId, data]);

  const steps = [
    {
      title: t("contact.contactInformation") || "Contact Information",
      content: (
        <ContactInformation
          data={data}
          form={form}
          contact={contact}
          createAs={createAs}
        />
      ),
    },
    {
      title: t("contact.contactAddress") || "Contact Address",
      content: <ContactAddress form={form} contact={contact} />,
    },
  ];

  return (
    <>
      <UserPrivateComponent permission="create-contact">
        <div className="px-20 py-5">
          <Steps size="small" current={current}>
            {steps.map((item, index) => (
              <Steps.Step key={index} title={item.title} />
            ))}
          </Steps>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: 50,
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}>
          <div>
            {steps.map((item, index) => (
              <div
                key={index}
                style={{ display: index === current ? "block" : "none" }}>
                {item.content}
              </div>
            ))}
          </div>

          <div style={{ marginTop: 24, textAlign: "right" }}>
            {current > 0 && (
              <Button
                className="mb-5"
                style={{ marginRight: 8 }}
                onClick={prev}>
                {t("common.previous")}
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button className="mb-5" type="primary" onClick={next}>
                {t("common.next")}
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button className="mb-5" type="primary" htmlType="submit">
                {t("common.submit")}
              </Button>
            )}
          </div>
        </Form>
        {!data?.id && (
          <Card
            className="my-5"
            title={<span className="text-center font-bold">{t("contact.importFromCSV") || "Import From CSV"}</span>}>
            <LeadsCreateMany
              urlPath={"contact"}
              loadAllThunk={loadAllContactPaginated}
              demoData={[
                [
                  "First Name",
                  "Last Name",
                  "Email",
                  "Mobile",
                  "Other Phone",
                  "Contact Owner",
                  "Lead Source",
                  "Country",
                  "Nationality",
                  "Date of Birth",
                  "Description",
                  "Created Time",
                ],
                [
                  "John",
                  "Doe",
                  "john@example.com",
                  "966500000000",
                  "966500000001",
                  "admin",
                  "Facebook",
                  "Saudi Arabia",
                  "Saudi",
                  "1990-01-01",
                  "Imported from CSV",
                  "2024-05-11 10:00:00",
                ],
              ]}
              invalidTags={["Contacts"]}
              title={t("contact.demoContacts") || "demo_contacts"}
            />
          </Card>
        )}
      </UserPrivateComponent>
    </>
  );
}
